import React from 'react';
import Nav from 'emerald-ui/lib/Nav';
import Tab from 'emerald-ui/lib/Tab';
import populateDocs from './utils/populateDocs';

const TabContainerData = populateDocs([{ component: Tab, componentName: 'Tab' }], 'Tab', Tab.Container, 'TabContainer');
const TabPaneData = populateDocs([{ component: Tab, componentName: 'Tab' }], 'Tab', Tab.Pane, 'TabPane');

const docsData = {
  ...TabContainerData,
  propsList: [
    {
      component: 'TAB',
      props: [...TabContainerData.propsList[0].props, ...TabPaneData.propsList[0].props],
    },
  ],
};

export default {
  ...docsData,
  description: (
    <span>
      The <span className="code">Tab</span> component provides easy access to the{' '}
      <span className="code">Tab.Container</span>, <span className="code">Tab.Content</span> and{' '}
      <span className="code">Tab.Pane</span> components. It must not be rendered. Instead, use the components mentioned
      earlier to create tabbed interfaces.
    </span>
  ),
  codeSamples: [
    {
      title: 'Default',
      scope: { Tab, Nav },
      code: `<Tab.Container defaultActiveKey="first">
  <Nav className="bg-inverse" theme="dark">
    <a id="first" href="/apps/docs/static">
      Tab 1
    </a>
    <a id="second" href="/apps/docs/static">
      Tab 2
    </a>
    <a id="third" href="/apps/docs/static" disabled>
      Tab 3
    </a>
  </Nav>
  <div className="bg-body">
    <Tab.Content>
      <Tab.Pane eventKey="first">
        <h3>Content of Tab 1</h3>
      </Tab.Pane>
      <Tab.Pane eventKey="second">
        <h3>Content of Tab 2</h3>
      </Tab.Pane>
      <Tab.Pane eventKey="third">
        <h3>Content of Tab 3</h3>
      </Tab.Pane>
    </Tab.Content>
  </div>
</Tab.Container>`,
    },
  ],
};
